import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { TextListModule } from '@libs/src/text-list/text-list.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { GroupMatchExclusionsDrawerModule } from '@main-client/src/app/group-match-exclusions-drawer/group-match-exclusions-drawer.module';
import { GroupMembershipDialogModule } from '@main-client/src/app/group-membership-dialog/group-membership-dialog.module';
import { MatchExclusionsDisplayModule } from '@main-client/src/app/match-exclusions-display/match-exclusions-display.module';
import { GetSegmentSelectionPipeModule } from '@main-client/src/app/pipes/get-segment-selection-pipe/get-segment-selection-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { PrivateSegmentsSelectionsModule } from '@main-client/src/app/private-segments-selections/private-segments-selections.module';

import { AccountEditDrawerService } from '@main-client/src/app/account-edit-drawer/account-edit-drawer.service';

import { AccountEditDrawerComponent } from './account-edit-drawer.component';

import { TranslationLookupListModule } from '../pipes/translation-lookup-list/translation-lookup-list.module';

@NgModule({
  declarations: [AccountEditDrawerComponent],
  imports: [
    AvatarModule,
    CommonModule,
    FlexLayoutModule,
    GetSegmentSelectionPipeModule,
    GroupMatchExclusionsDrawerModule,
    GroupMembershipDialogModule,
    MatchExclusionsDisplayModule,
    MatIconModule,
    NzDrawerModule,
    NzToolTipModule,
    PrivateSegmentsSelectionsModule,
    RouterModule,
    TextListModule,
    TtcButtonSharedModule,
    NzSkeletonModule,
    TranslationLookupModule,
    TranslationLookupListModule,
  ],
  providers: [AccountEditDrawerService],
})
export class AccountEditDrawerModule {}
